import React, { useEffect, useState } from "react";
import {
  Box,
  Breadcrumbs,
  Button,
  Divider,
  FormHelperText,
  Grid,
  Link,
  TextareaAutosize,
  Typography,
  useTheme,
} from "@mui/material";
import {
  AutoCompleteField,
  InputDatePicker,
  InputField,
  PhoneField,
} from "forms/hoc/formfield";
import useForm from "forms/hooks/useForm";
import { SeoValidation } from "forms/hooks/validateRules";
import { Failed, Success } from "forms/helpers/toast.helper";

import { commonService } from "forms/helpers/common.service";
import { useLocation, useNavigate } from "react-router-dom";
import { parsePhoneNumber } from "forms/hooks/customHook";
import { errorMessage } from "forms/helpers/function.helper";
import Loader from "ui-component/Loader";
import dayjs from "dayjs";

const EditSeo = () => {
  const [isLoading, setIsLoading] = useState<Boolean>(false);
  const navigate = useNavigate();
  const initialValues = {
    title: "",
    keywords: "",
    description: "",
  };
  const theme = useTheme();
  const location = useLocation();


  const getSeoDetails = () => {
    setIsLoading(true);
    commonService
      .getServices(`/admin/seo_details/${location?.state?.id}`)
      .then((res) => {
        const userData = res?.data?.data;
        setPatchValue({
            title: userData?.title,
            keywords: userData?.keywords,
            description : userData?.description,
            page :  userData?.page
        });
        setIsLoading(false);
      })
      .catch((error) => {
        Failed(errorMessage(error, "Oops! Something Went Wrong"));
        setIsLoading(false);
      });
  };
  useEffect(() => {
    if (location?.state?.id) {
      getSeoDetails();
    }
  }, []);

  const handleSubmitUser = () => {
    setIsLoading(true);


    try {
      const formData: any = {
        title: values?.title,
        keywords: values?.keywords,
        description : values?.description,
        updatedAt: new Date()
      };
      if (location?.state?.id) {
        const EditedData = commonService.patchService(
          `/admin/update-seodata/${location?.state?.id}`,
          formData
        );
        EditedData?.then((res) => {
          Success(res?.data?.message);
          navigate("/seo_management");
          setIsLoading(false);
        }).catch((error) => {
          Failed(errorMessage(error, "Oops! Something went wrong"));
          setIsLoading(false);
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    setPatchValue,
  } = useForm(initialValues, handleSubmitUser, SeoValidation);

  return (
    <Box sx={{ padding: "1% 0" }}>
      {isLoading && <Loader />}
      <Breadcrumbs aria-label="breadcrumb" sx={{ padding: "1% 1.5%" }}>
        <Link underline="hover" color="inherit" href="/seo_management">
        Seo Management
        </Link>

        {location?.state?.id && (
          <Typography color="text.primary">Edit Seo</Typography>
        )}
        {location?.state?.id && <Typography>{values?.page} </Typography>}
      </Breadcrumbs>
      <Box component={"form"} onSubmit={handleSubmit}>
        <Box sx={{ height: `calc(78vh - 78px)`, overflowY: "scroll" }}>
          <Box
            sx={{
              mt: "2%",
              padding: "20px",
              borderRadius: "8px",
            }}
          >
            <Typography sx={{ fontWeight: "600", fontSize: "20px" }}>
              Edit Seo
            </Typography>
            <Divider sx={{ mt: 2 }} />
            <Grid container spacing={2}>
              <Grid item lg={12}>
                <InputField
                  fieldName="Title"
                  values={values?.title || ""}
                  name="title"
                  errors={errors?.title}
                  handleChange={handleChange}
                  id="title"
                />
              </Grid>
              <Grid item lg={12}>
                <InputField
                  fieldName="Keywords"
                  isRequired={false}
                  values={values?.keywords || ""}
                  name="keywords"
                  errors={errors?.keywords}
                  handleChange={handleChange}
                  id="keywords"
                />
              </Grid>
              <Grid item lg={12}>
              <Typography
                fontWeight={500}
                fontSize={"14px"}
                marginTop={2}
                marginBottom={1}
              >
                Description
                <span style={{ color: "red" }}>*</span>
              </Typography>

              <Box>
                <TextareaAutosize
                  id="description"
                  name="description"
                  value={values?.description || ""}
                  onChange={handleChange}
                  placeholder=""
                  minRows={6}
                  maxRows={6}
                  style={{
                    width: "100%",
                    fontFamily: "InterVariableFont",
                    resize: "none",
                    fontWeight: 400,
                    fontSize: "16px",
                    border: errors?.details ? "1px solid red" : "",
                  }}
                />
                <Box
                  sx={{
                    textAlign: "left",
                    marginTop: "6px",
                    fontWeight: 400,
                    fontSize: "12px",
                    color: "#6B778C",
                  }}
                >
                  {values?.details?.length ? values?.details?.length : 0}/500
                </Box>
                {errors?.description && (
                  <FormHelperText
                    error
                    id="standard-weight-helper-text-email-login"
                    sx={{ mt: 0.3, p: 0 }}
                  >
                    {errors?.description}
                  </FormHelperText>
                )}
              </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            flexDirection: "row",
            gap: 2,
            mt: 1,
            boxShadow: " 0px -4px 8px 0px #33414D1A",
            alignItems: "center",
            height: "90px",
          }}
        >
          <Button
            sx={{
              padding: "10px 50px",
              background: "transparent",
              border: `1px solid ${theme.palette.primary.buttonOrange}`,
              mt: 2,
            }}
            onClick={() => navigate(-1)}
          >
            Cancel
          </Button>
          <Button type="submit" sx={{ padding: "10px 50px", mt: 2, mr: 2 }}>
            Update
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default EditSeo;
